import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components';

import "./Theme.css"

export default function Theme(props) {
    
    const themeContext = useContext(ThemeContext);

    return (
        <div className="theme">
            <label className="theme__switch">
            <input onClick={props.toggle} onChange={() => null} type="checkbox" checked={themeContext.main === 'light' ? false : true}
            /> 
            <span className="theme__slider round"></span>
            </label>
        </div>
    )
}
